import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';

export default class ClaimService {
    static simplifiedSearchPolicy(searchDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'), 'simplifiedSearchPolicy_ax', [searchDTO], additionalHeaders);
    }

    static searchPolicy(policySummary, criteriaDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'), 'searchPolicy_ax', [policySummary, criteriaDTO], additionalHeaders);
    }

    static getClaimDetailWithOutDocumentsAx(claimNumber,loadDocument, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'), 'getClaimDetailWithOutDocuments_ax', [claimNumber,loadDocument], additionalHeaders);
    }

    static retrieveAvailableLossCausesAX(policyOrigin, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'), 'allowLossCause', [policyOrigin], additionalHeaders);
    }

    static retrieveAvailableCitiesAX(stateCode, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'), 'searchStateCities', [stateCode], additionalHeaders);
    }

    static searchAllowAccidentTypePR(policyNumber, producerCode, policyTypeCode,
        additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'), 'allowAccidentType', [policyNumber, producerCode, policyTypeCode], additionalHeaders);
    }

    static searchAllowAssistanceTypePR(policyNumber, accidentTypeCode, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'), 'allowAssistanceType', [policyNumber, accidentTypeCode], additionalHeaders);
    }

    static reportQuickClaimSummary(reportDTO, policyDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'), 'reportQuickClaimSummary_AX', [reportDTO, policyDTO], additionalHeaders);
    }

    static nagCalculationAmount(nagCode, deduction, isPorcent, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'), 'nagCalculationCost', [nagCode, deduction, isPorcent], additionalHeaders);
    }
}
